<template>
	<symbol :id="`${prefix}draft`" viewBox="0 0 16 16">
		<circle
			cx="8"
			cy="8"
			r="7"
			stroke-width="2"
			stroke-dasharray="2.9 2.6"
			class="sign"
		/>
	</symbol>
</template>

<script>
export default {
	name: 'NiIconSymbolDraft',


	props: {
		prefix: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="sass" scoped >
.sign
	fill: none
	stroke: var(--ni-icon-sign, #{$nice_color-gray_dark})
</style>
